export default __webpack_public_path__ + "static/media/few-clouds-night.b1024a48.svg";